<template>
  <div class="list">
    <router-link v-for="(item, index) in items" class="item" :class="[{ active: item.link === $route.path }, { disable: item.disable }]" :key="index" :to="item.link">
      {{ item.title }}
    </router-link>

    <div class="left">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TabLink',
  props: {
    items: {
      type: Array,
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, 0.03);
  position: relative;
  display: flex;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid #f6f6f6;
  border-radius: 0.25rem;
  padding: 10px;
  position: relative;
  margin-bottom: 20px;
  min-height: 62px;
}

.item {
  margin: auto 15px;
  font-size: 15px;
  color: #4e4e56;
}

.active {
  padding: 10px;
  color: #556ee6;
  background: rgba(5, 119, 175, 0.1);
  border-radius: 3.25px;
}

.left {
  position: absolute;
  top: 15px;
  left: 18px;
}

.disable {
  opacity: 0.5;
  pointer-events: none;
}
</style>
